import React from 'react';
import { motion } from 'framer-motion'; // For lazy loading images
import resibanner from '../images/Residential/Hero-image.png'
import resichoose from '../images/Residential/whychooseus.png'
import ResidentialsI from '../components/inquiries/Residential'; // Importing the Residentials component
const Residential = () => {
    

    const data ={
        "services": [
          "Shower Enclosures",
          "Custom Shower Design",
          "Frameless Shower Doors",
          "Frameless Sliding Doors",
          "Fixed Panels",
          "House Windows",
          "Window Screens",
          "Sunrooms",
          "Screened In Patios",
          "Patio Doors",
          "Custom Table Tops",
          "Mirrors",
          "Cabinet Doors",
          "Picture Frames",
          "Fireplace Glass"
        ],
        "galleryImages": [
          "/images/bathroom1.jpg",
          "/images/sunroom1.jpg",
          "/images/showerdoor1.jpg"
        ]
      }
      
    return (
        <motion.div
            className='bg-secondary text-neutral-100 min-h-screen '
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            {/* Hero Banner */}
            <motion.div
                className='bg-primary h-screen flex flex-col justify-center items-center relative  overflow-hidden '
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
            >
                {/* Background Image */}
                <div
                    className='absolute top-0 left-0 w-full h-full bg-cover bg-center '
                    style={{ backgroundImage: `url(${resibanner})` }}
                >
                    {/* Overlay for better text visibility */}
                    <div className='absolute top-0 left-0 w-full h-full bg-black opacity-50'></div>
                </div>

                {/* Hero Content */}
                <motion.h1
                    className='text-5xl font-playfair-display text-secondary z-10'
                    initial={{ y: -50 }}
                    animate={{ y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    Residential Glass Services
                </motion.h1>
                <motion.p
                    className='text-lg font-nunito-sans text-secondary z-10 mb-12'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    Transform your home with custom-designed, high-quality glass solutions that blend beauty and functionality.
                </motion.p>
                
            </motion.div>


            {/* Image & Introduction */}
            <motion.div
                className='flex flex-col lg:flex-row items-center gap-8 mb-20 bg-primary p-28'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
            >
                <div className='flex-1 w-full '>
                    <img src={resichoose} alt='Residential Glass' className='rounded-xl shadow-lg object-cover h-96 w-full' />
                </div>
                <div className='flex-1 w-full'>
                    <h2 className='text-2xl md:text-3xl font-inter mb-3 text-secondary'>Why Choose Us?</h2>
                    <p className='font-nunito-sans text-base md:text-lg leading-relaxed text-secondary'>
                        From sleek frameless shower doors to sunroom installations, our residential services are tailored to match your unique home aesthetic. We bring craftsmanship and care to every project.
                    </p>
                </div>
            </motion.div>

            {/* Highlights / Featured Services */}
            <motion.div
                className='m-20'
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
            >
                <h2 className='text-2xl md:text-3xl font-inter mb-8 text-center text-primary'>Featured Solutions</h2>
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8'>
                    {[
                        { title: 'Shower Enclosures', desc: 'Custom glass enclosures for any bathroom layout.' },
                        { title: 'Custom Shower Design', desc: 'Designed to fit your vision and space.' },
                        { title: 'Frameless Shower Doors', desc: 'Seamless and stylish door solutions.' },
                    ].map((service, idx) => (
                        <motion.div
                            key={idx}
                            className='bg-white p-6 rounded-xl shadow hover:shadow-2xl transition-all'
                            whileHover={{ scale: 1.05 }}
                        >
                            <h3 className='font-inter text-xl text-primary mb-2'>{service.title}</h3>
                            <p className='text-sm md:text-base text-primary leading-relaxed'>{service.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </motion.div>

            {/* Full Services List as Grid Cards */}
            <motion.div
                className='m-20'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.6 }}
            >
                <h2 className='text-2xl md:text-3xl font-inter mb-8 text-center text-primary'>All Residential Services We Offer</h2>
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
                    {data.services.map((item, idx) => (
                        <motion.div
                            key={idx}
                            whileHover={{ scale: 1.05 }}
                            className='bg-white p-5 rounded-xl shadow-md flex items-start gap-4 transition-all duration-300 hover:shadow-2xl'
                        >
                            <p className='text-base font-nunito-sans text-primary'>{item}</p>
                        </motion.div>
                    ))}
                </div>
            </motion.div>

            {/* Gallery / Visual Inspiration */}
            <motion.div
                className='m-20'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.7 }}
            >
                <h2 className='text-2xl md:text-3xl font-inter mb-8 text-primary'>Gallery Inspiration</h2>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6'>
                    {data.galleryImages.map((img, idx) => (
                            <motion.img
                                src={img}
                                alt={`Residential work ${idx + 1}`}
                                className='rounded-lg shadow-lg hover:shadow-2xl w-full h-auto object-cover'
                                whileHover={{ scale: 1.03 }}
                            />
                    ))}
                </div>
            </motion.div>
         <ResidentialsI/>
        </motion.div>
    );
};

export default Residential;
